import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('my-enter-search', {
    staticClass: "mb-10",
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "value": "1",
      "data-permission": "finance_warehouse_cost_statement_code_type",
      "id": "finance_warehouse_cost_statement_code_type"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.t("单号")))])], 1), _c('a-input', {
    staticClass: "form-item-input",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "data-permission": "finance_warehouse_cost_statement_code_value",
      "id": "finance_warehouse_cost_statement_code_value",
      "allowClear": "",
      "maxLength": 100
    },
    model: {
      value: _vm.wisCode,
      callback: function ($$v) {
        _vm.wisCode = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "wisCode"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "ml-15 form-item-select",
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u4ED3\u5E93"),
      "data-permission": "finance_warehouse_cost_statement_warehouse_code",
      "id": "finance_warehouse_cost_statement_warehouse_code",
      "mode": "multiple",
      "maxTagCount": 1,
      "placeholder": _vm.t('仓库'),
      "show-tip": "",
      "allowClear": "",
      "show-search": ""
    },
    model: {
      value: _vm.searchData.warehouse_code_list,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "warehouse_code_list", $$v);
      },
      expression: "searchData.warehouse_code_list"
    }
  }, _vm._l(_vm.warehouseList, function (item) {
    return _c('a-select-option', {
      key: item.warehouse_code
    }, [_vm._v(_vm._s(item.warehouse_name_text))]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "value": "1",
      "data-permission": "finance_warehouse_cost_statement_time_type",
      "id": "finance_warehouse_cost_statement_time_type"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.t("发生时间")))])], 1), _c('my-range-picker', {
    attrs: {
      "data-permission": "finance_warehouse_cost_statement_time_value",
      "id": "finance_warehouse_cost_statement_time_value",
      "placeholder": [_vm.t('开始'), _vm.t('结束')],
      "limit-range-day": 186,
      "format": "YYYY/MM/DD",
      "allow-clear": false
    },
    on: {
      "change": _vm.handleTimeArrChange
    },
    model: {
      value: _vm.searchData.timeArr,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "timeArr", $$v);
      },
      expression: "searchData.timeArr"
    }
  }), _c('a-popover', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v(_vm._s(_vm.t("时间跨度筛选最长支持186天。")))]), _c('a-icon', {
    staticClass: "ml-5",
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "type": "question-circle"
    }
  })], 1)], 1), _c('span', {
    staticClass: "ml-20",
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_c('a-button', {
    attrs: {
      "ghost": "",
      "data-sign": "finance_warehouse_rent_query",
      "type": "primary",
      "data-permission": "finance_warehouse_cost_statement_search",
      "id": "finance_warehouse_cost_statement_search",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(" " + _vm._s(_vm.t("搜索")) + " ")], 1), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "data-sign": "finance_warehouse_rent_reset",
      "data-permission": "finance_warehouse_cost_statement_reset",
      "id": "finance_warehouse_cost_statement_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.t("重置")))])], 1)], 1), _c('div', {
    staticClass: "ovh mb-15"
  }, [_c('span', {
    staticClass: "fl",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_vm._v(_vm._s(_vm.t("已选")) + _vm._s(_vm.t("common", ":")) + " " + _vm._s(_vm.selectedList.length))]), _c('div', {
    staticClass: "ml-20 fl"
  }, [_c('a-dropdown', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'warehouse_cost_statement_export',
      expression: "'warehouse_cost_statement_export'"
    }]
  }, [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-permission": "finance_warehouse_cost_statement_export_all",
      "id": "finance_warehouse_cost_statement_export_all",
      "data-sign": "finance_warehouse_cost_statement_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.t("导出全部")))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-permission": "finance_warehouse_cost_statement_export_selected",
      "id": "finance_warehouse_cost_statement_export_selected",
      "data-sign": "finance_warehouse_cost_statement_export_selected",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.t("导出已选")))])], 1), _c('a-button', [_vm._v(" " + _vm._s(_vm.t("导出主表")) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1), _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'warehouse_cost_statement_download_bulk',
      expression: "'warehouse_cost_statement_download_bulk'"
    }],
    staticClass: "ml-15",
    attrs: {
      "data-permission": "finance_warehouse_cost_statement_export_details",
      "id": "finance_warehouse_cost_statement_export_details",
      "data-sign": "finance_warehouse_cost_statement_export_details",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u660E\u7EC6")
    },
    on: {
      "click": function ($event) {
        return _vm.handlExportDetails(false, _vm.selectedList);
      }
    }
  }, [_vm._v(_vm._s(_vm.t("导出明细")))])], 1)]), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "columns": _vm.columns,
      "data-sign": "finance_warehouse_cost_statement_list",
      "fixed-header": "",
      "is-filter-box": "",
      "useMouseTool": "",
      "name": "warehouseCostStatementList",
      "data-source": _vm.dataList,
      "row-selection": {
        selectedRowKeys: _vm.selectedList,
        onChange: _vm.onSelectChange
      },
      "row-key": "wis_code",
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "total_amount",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('money-format', {
          attrs: {
            "num": record.total_amount,
            "formatter": true
          }
        })], 1);
      }
    }, {
      key: "isdb_volume",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('money-format', {
          attrs: {
            "num": record.isdb_volume,
            "formatter": true
          }
        })], 1);
      }
    }, {
      key: "isdb_total_qty",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('money-format', {
          attrs: {
            "num": record.isdb_total_qty
          }
        })], 1);
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [_c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'warehouse_cost_statement_download',
            expression: "'warehouse_cost_statement_download'"
          }],
          attrs: {
            "data-sign": "finance_warehouse_cost_statement_details_download",
            "data-permission": "finance_warehouse_cost_statement_detail_download",
            "id": "finance_warehouse_cost_statement_detail_download",
            "fbu-analyse-name": $t("\u660E\u7EC6\u4E0B\u8F7D")
          },
          on: {
            "click": function ($event) {
              return _vm.handlExportDetails(true, [record.wis_code]);
            }
          }
        }, [_vm._v(_vm._s(_vm.t("明细下载")))])]);
      }
    }, {
      key: "warehouse",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [record['warehouse_code'] ? _c('span', [_vm._v(_vm._s(record["warehouse_code"]))]) : _vm._e(), record['warehouse_name'] ? _c('span', [_vm._v("[" + _vm._s(record["warehouse_name"]) + "]")]) : _vm._e()]);
      }
    }, {
      key: "note",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('text-ellipses', {
          attrs: {
            "data": record.note,
            "width": 140
          }
        })], 1);
      }
    }])
  }, [_c('template', {
    slot: "isdb_volume_title"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('体积(m³)')))]), _c('a-popover', {
    attrs: {
      "content": _vm.t('指的是单据内商品体积之和')
    }
  }, [_c('a-icon', {
    staticClass: "ml-5",
    attrs: {
      "type": "question-circle"
    }
  })], 1)], 1)], 2)], 1), _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "isFixed": "",
      "name": "warehouseCostStatementList",
      "value": _vm.searchData.page_index,
      "total": _vm.total,
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };